(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Transportation', Transportation);

    Transportation.$inject = ['$resource'];

    function Transportation ($resource) {
        var resourceUrl =  'api/transportations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
